import { schemes, zSchema } from "@zeal/common";

import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";

export const getPayAlertsRequestSchema = zSchema.object({
  companyID: schemes.companyID(),
});

export type TGetPayAlertsArgs = zSchema.infer<typeof getPayAlertsRequestSchema>;

export const payAlertItemKindSchema = zSchema.enum([
  "paystub",
  "transaction",
  "contractor_payment",
]);

export type TPayAlertItemKind = zSchema.infer<typeof payAlertItemKindSchema>;

export const payAlertItemSchema = zSchema.object({
  id: zSchema.string(),
  kind: payAlertItemKindSchema,
  amount: zSchema.number(),
  occurredAt: zSchema.string(),
  workerFirstName: zSchema.string(),
  workerLastName: zSchema.string(),
  employerCheckID: zSchema.string().optional(),
  paystubID: zSchema.string().optional(),
  contractorPaymentID: zSchema.string().optional(),
  transactionID: zSchema.string().optional(),
  statusDetail: zSchema.string().optional(),
});

export type TPayAlertItem = zSchema.infer<typeof payAlertItemSchema>;

export const getPayAlertsResponseSchema = zSchema.object({
  failed_employee_checks: zSchema.array(payAlertItemSchema),
  failed_contractor_payments: zSchema.array(payAlertItemSchema),
  returned_employee_checks: zSchema.array(payAlertItemSchema),
  returned_contractor_payments: zSchema.array(payAlertItemSchema),
});

export type TGetPayAlertsResponseData = zSchema.infer<
  typeof getPayAlertsResponseSchema
>;

export type IPayAlertItem = TPayAlertItem;
export type IGetPayAlertsArgs = TGetPayAlertsArgs;
export type IGetPayAlertsResponseData = TGetPayAlertsResponseData;
export type IGetPayAlertsResponse = IApiResponse<TGetPayAlertsResponseData>;
